module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 15-cc0d1068c21122c5233ec8e844a6c3b4.jpg";